//Mark: used in V2
import { SbBlokData, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import RichTextElement from "./RichTextElement"
import LayoutItem from "../V2/Layouts/LayoutItem"

const RichTextBlock = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.RichTextBlock>) => {
  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      {...storyblokEditable(blok as SbBlokData)}
      className="col-span-4 md:col-span-6 lg:col-span-12 [&_b]:font-bold [&_h1]:mb-20 [&_h2]:mb-20 [&_h3]:mb-20 [&_h4]:mb-20 [&_h5]:mb-20 [&_h6]:mb-20 [&_li]:mb-[5px] [&_li_p]:mb-0 [&_ol]:mb-20 [&_ol]:list-decimal [&_ol]:pl-40 [&_p]:mb-20 [&_p]:leading-tight [&_ul]:mb-20 [&_ul]:list-disc [&_ul]:pl-40"
    >
      <RichTextElement
        content={blok.body}
        textColor={blok.textColor}
        linkColor={blok.linkColor}
        textAlign={blok.textAlign}
      />
    </LayoutItem>
  )
}

export default RichTextBlock
